export const IDB_DIRECTORY_HANDLE_KEY = "IDB_DIRECTORY_HANDLE";
